import useCurrentUserPersonTypeSelector from './useCurrentUserPersonTypeSelector'

const useCurrentUserIsAuthPersonTypes = (personTypes) => {
  const currentUserPersonTypeSelector = useCurrentUserPersonTypeSelector()

  return personTypes?.some((authorizedPersonType) => authorizedPersonType === currentUserPersonTypeSelector)
}

export default useCurrentUserIsAuthPersonTypes
